import DialogModal from '@/modules/common/components/Modal/DialogModal';
import { Typography } from '@pw-tech/omni-ui';
import React from 'react';
const ScoreCalculation = ({
  onClose
}: {
  onClose: () => void;
}) => {
  return <>
      <DialogModal isOpen title="How is score calculated?" onClose={onClose} showHeader showSeparator showFooter={false} showCancelButton={false} showCloseIcon showSubmitButton={false} closeOnOutsideClick size="medium" data-sentry-element="DialogModal" data-sentry-source-file="ScoreCalculation.tsx">
        <div className="flex flex-col gap-1 p-4">
          <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="ScoreCalculation.tsx">1. Each correct answer gives +4 marks</Typography>
          <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="ScoreCalculation.tsx">2. Each incorrect answer gives -1 mark.</Typography>
          <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="ScoreCalculation.tsx">3. 0 marks for unattempted questions</Typography>
        </div>
      </DialogModal>
    </>;
};
export default ScoreCalculation;